import React from "react";
import { Layout } from "../components/Layout";
import { CreateAnimal } from "../modules/animals/elements/create-animal";

const PageCreateAnimal = () => (
  <Layout>
    <CreateAnimal />
  </Layout>
);

export default PageCreateAnimal;
